import { useCallback } from 'react'

import Flex from '@/elements/Flex'
import Text from '@/elements/Text'
import NotificationSettings from '@/components/NotificationSettings'
import useBreakpoints from '@/hooks/useBreakpoints'
import { updateOrganizationNotificationSettings, useGetOrganizationNotificationsSettings } from '@/api/notifications'
import type { NotificationSettingResponse } from '@/api/types/Notification'
import toast from '@/utils/toast'

function OrganizationNotifications() {
  const { isTablet, isMobile } = useBreakpoints()

  const { data: organizationNotifications, isLoading, refetch } = useGetOrganizationNotificationsSettings()

  const submitUpdateNotifications = useCallback(async (
    id: NotificationSettingResponse['id'],
    value: NotificationSettingResponse['value']
  ) => {
    try {
      await updateOrganizationNotificationSettings(id, value)
      toast.success('Notification updated')
    } catch {
      toast.error('Failed to update notification')
    }
    await refetch()
  }, [refetch])

  return (
    <Flex
      className='card'
      wrap
      grow
      wfull
      inline={!isTablet}
      gap={7}
      p={isMobile ? 3 : isTablet ? 5 : 7}
    >
      <Flex fraction={4} gap={2} wfull>
        <Text variant='h3'>Notifications</Text>
        <Text color='black-light-40'>
          Choose Organization settings for notifications about important alerts.
        </Text>
      </Flex>
      <Flex fraction={6} wfull>
        <NotificationSettings
          loading={isLoading}
          notifications={organizationNotifications?.data || []}
          onSave={submitUpdateNotifications}
        />
      </Flex>
    </Flex>
  )
}
export default OrganizationNotifications
